import { render, staticRenderFns } from "./Jo.vue?vue&type=template&id=95580528&scoped=true&"
import script from "./Jo.vue?vue&type=script&lang=js&"
export * from "./Jo.vue?vue&type=script&lang=js&"
import style0 from "./Jo.vue?vue&type=style&index=0&id=95580528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95580528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
